import { useEffect } from 'react';

import { usePreferences } from '@atom/hooks/usePreferences';
import { useUserProfile } from '@atom/hooks/useUserProfile';
import { getCurrentUserLocation, getGeoJSONLocation } from '@atom/map';
import api from '@atom/utilities/api';
import { USERS_ENDPOINT } from '@atom/utilities/endpoints';

import ArcgisLayersProvider from './arcgis/ArcgisLayersProvider';
import useMapSchemas from './hooks/useMapSchemas';
import KmlLayersProvider from './kml/KmlLayersProvider';
import Drawer from './Drawer';
import MapPortalDataProvider from './MapPortalDataProvider';
import MapWrapper from './MapWrapper';
import SideNav from './SideNav';

import classes from './mapPortal.module.css';

const MapPortal = () => {
  const { schemas: allSchemas, loading: schemasLoading } = useMapSchemas();
  const preferences = usePreferences();
  const { userId } = useUserProfile();

  // Patch current user's location on mount
  useEffect(() => {
    const updateUserLocation = async () => {
      const location = await getCurrentUserLocation();

      if (location && userId) {
        api.patch(`${USERS_ENDPOINT}/${userId}`, {
          location: getGeoJSONLocation(location),
        });
      }
    };

    updateUserLocation();
  }, [userId]);

  return (
    <div className={classes.container}>
      <div className={classes.title}>Map</div>
      <div className={classes.body}>
        <SideNav />
        <MapPortalDataProvider
          schemas={allSchemas}
          schemasLoading={schemasLoading}
          clusterDensity={preferences.map?.clusterDensity ?? 'default'}
        >
          <ArcgisLayersProvider>
            <KmlLayersProvider>
              <Drawer />
              <div className={classes.mapWrapper}>
                <MapWrapper />
              </div>
            </KmlLayersProvider>
          </ArcgisLayersProvider>
        </MapPortalDataProvider>
      </div>
    </div>
  );
};

export default MapPortal;
